module.exports = __webpack_public_path__ + "img/hohlschnitt_kobaltblau_ral5013.a7ab28ad.jpg";